<div class="all-content" id="all-content-create-user">
    <div class="top">
        <div class="toggle"></div>

        <div class="save" (click)="isEdit = true" *ngIf="!isEdit ">
            {{ getLanguages('edit') }}
        </div>

        <div class="save cancel" (click)="cancel()" *ngIf="isEdit">
            {{ getLanguages('cancel') }}
        </div>

        <div class="save" (click)="save()" *ngIf="isEdit">
            {{ getLanguages('conclude') }}
        </div>

        <i class="fas fa-xmark" (click)="exitModal()"></i>
    </div>
    <div class="row row-title">
        <div class="title">
            {{ getLanguages('businessSolution/modal/accessUser/title') }}
        </div>
    </div>

    <div class="row" style="margin-top: 2vh;">
        <div class="item display-flex-item" *ngIf="isShowCascade">
            <span>
                {{ getLanguages('businessSolution/modal/accessUser/applyInCascade') }}
                <i class="fas fa-question-circle"
                    matTooltip="{{ getLanguages('businessSolution/modal/accessUser/applyInCascadeTooltip') }}"></i>
            </span>
            <mat-checkbox class="checkbox" [color]="task.color" [ngModel]="isCascade" (change)="toggleCascade()"
                [disabled]="!isEdit">
            </mat-checkbox>
        </div>
    </div>

    <div class="div-search">
        <div class="search">
            <input type="text" [(ngModel)]="searchText" (keyup.enter)="search()">          
                <i class="fas fa-xmark cancel-search" *ngIf="isSearch" (click)="clearFilter()"></i>
        </div>
        <button (click)="search()">
            {{ getLanguages('search') }}
        </button>
    </div>
    <span class="title-table">
        {{ getLanguages('slugs/user') }}
    </span>
    <div class="table">
        <table mat-table [dataSource]="getRows()">
            <ng-container matColumnDef="Access">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox class="checkbox" [color]="task.color" [ngModel]="isAllSelected()"
                        (change)="toggleAllRows()" [disabled]="!isEdit">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element; let i = index;">
                    <mat-checkbox class="checkbox" [color]="task.color" [ngModel]="element.access"
                        (change)="setAcess(element);" [disabled]="!isEdit">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="User">
                <th mat-header-cell *matHeaderCellDef>
                    <span>
                        {{ getLanguages('businessSolution/modal/accessUser/user') }}
                    </span>
                </th>
                <td mat-cell *matCellDef="let element; let i = index;">
                    <span class="title-corporation">
                        {{ element.name }}
                    </span>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <div class="div-paginator">
        <div class="paginator">
            <span>
                {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
            </span>
            <button [matMenuTriggerFor]="menu" class="itens-per-page">
                {{ getItemsPerPage()}}
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="choseItemsPage(5)">5</button>
                <button mat-menu-item (click)="choseItemsPage(10)">10</button>
                <button mat-menu-item (click)="choseItemsPage(20)">20</button>
            </mat-menu>
            <span>
                {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
            </span>
            <span class="totalPages">
                {{ getTotalNumberPages() }}
            </span>
            <button [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'"
                [disabled]="getCurrentPages() === 1"
                (click)="setCurrentPages(getCurrentPages() - 1); getDisplayedRows();">
                <i class="fa-solid fa-angle-left"></i>
            </button>
            <input type="number" disabled [ngModel]="getCurrentPages()" (blur)="getTotalPages()">
            <button [ngClass]="getCurrentPages() >= getTotalNumberPages()  ? 'disabled-arrow' : 'arrow'"
                [disabled]="getCurrentPages() >= getTotalNumberPages()"
                (click)="setCurrentPages(getCurrentPages() + 1);getTotalPages();">
                <i class="fa-solid fa-angle-right"></i>
            </button>
        </div>
    </div>
</div>